import { useAgentsQuery } from 'hooks/useAgentsQuery'
import { Media } from 'media'
import { ComponentType } from 'react'
import { SalesDesktop } from './sales-desktop'
import { SalesMobile } from './sales-mobile'

export const Sales: ComponentType = () => {
  const { data } = useAgentsQuery({
    variables: { query: { team: 'sales' } },
  })

  return (
    <>
      <Media at="xs">
        <SalesMobile agents={data?.agents.data ?? []} />
      </Media>
      <Media greaterThan="xs">
        <SalesDesktop agents={data?.agents.data ?? []} />
      </Media>
    </>
  )
}
